import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from './core/services/data.service';
import { UtilsService } from './core/services/utils.service';
import { environment } from 'src/environments/environment';

declare const gtag: Function;
export let browserRefresh = false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  environmentName = environment.environmentName;
  title = '4Agri';
  stylesheetString = 'aft';

  constructor(
    private translate: TranslateService,
    private dataService: DataService,
    private router: Router,
    private utilsService: UtilsService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-WVH03M6EEK', { page_path: event.urlAfterRedirects });
      }
    });
  }

  ngOnInit() {
    this.stylesheetString = this.utilsService.getStylesheetString();
    this.translate.setDefaultLang(this.dataService.getLanguage());
    this.utilsService.setHostName(location.host);

    // Set customer theme color dynamically via CSS custom property
    this.setCustomerTheme();

    this.setFavicon();
    this.setTitle();
    // this.router.events.subscribe(event => this.closeFilterOnNavigation(event));
  }

  /**
   * Sets the customer-specific theme color by updating CSS custom property
   * This allows single build to serve all customers with correct branding
   *
   * La tabella colori per tenant era duplicata qui: ora la fonte unica è
   * utilsService.getMainColor(), che applica già la stessa precedenza
   * (localStorage → brand del tenant → default).
   */
  private setCustomerTheme() {
    const mainColor = this.utilsService.getMainColor();

    // Imposta --main-color e tutte le derivate alpha/dark sul documento
    this.utilsService.applyThemeColorVars(mainColor);
  }

  setFavicon() {
    var headID = document.getElementsByTagName('head')[0];
    // Riusa il <link rel="icon"> statico di index.html invece di aggiungerne un secondo:
    // con due link Chrome può tenersi quello in cache e ignorare il nuovo.
    var link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      headID.appendChild(link);
    }
    link.type = 'image/png';
    var hostname = location.host;
    //to debug
    //var hostname = 'compact.actiafleet4agri.com';
    if (hostname.indexOf('argofleet.argotractors.com') !== -1)
      hostname = 'argofleet.argotractors.com';
    if (hostname.indexOf('mccormickfleet.argotractors.com') !== -1)
      hostname = 'mccormickfleet.argotractors.com';
    if (hostname.indexOf('landinifleet.argotractors.com') !== -1)
      hostname = 'landinifleet.argotractors.com';
    if (hostname.indexOf('www.u-control.cloud') !== -1)
      hostname = 'u-control.cloud';
    if (hostname.indexOf('test.ucontrol.actiafleet4agri.com') !== -1)
      hostname = 'u-control.cloud';
    if (hostname.indexOf('essential-connect.it') !== -1 || hostname.indexOf('test.cela.actiafleet4agri.com') !== -1)
      hostname = 'cela.com';
    // ?v= forza il browser a riscaricare la favicon quando cambia (Chrome la cache a lungo)
    link.href =
      'assets/styles/customers/' + hostname + '/images/favicon.png?v=2';
  }

  getTitleString() {
    let host = location.host;
    // to debug
    //host = 'test.mccormickfleet.argotractors.com';
    if (host.indexOf('argofleet.argotractors.com') !== -1) return 'Argo Fleet';
    else if (host.indexOf('mccormickfleet.argotractors.com') !== -1)
      return 'McCormick Fleet';
    else if (host.indexOf('landinifleet.argotractors.com') !== -1)
      return 'Landini Fleet';
    else if (host.indexOf('compact.actiafleet4agri.com') !== -1)
      return 'COMPACT CONNECT';
    else if (host.indexOf('www.u-control.cloud') !== -1 || host.indexOf('test.ucontrol.actiafleet4agri.com') !== -1)
      return 'U-Control';
    else if (host.indexOf('essential-connect.it') !== -1 || host.indexOf('test.cela.actiafleet4agri.com') !== -1)
      return 'CELA';
    else
      return 'ACTIA Fleet Agriculture';
  }

  setTitle() {
    let titleString = this.getTitleString();
    let headID = document.getElementsByTagName('head')[0];
    let title = document.createElement('title');
    title.textContent = titleString;
    headID.appendChild(title);
  }

  closeFilterOnNavigation(event) {
    if (event instanceof NavigationEnd) {
      if (!event.url.includes('/auth')) {
      }
    }
  }
}
